import { ReactNativeOptions } from '@sentry/react-native';
import { Platform } from 'react-native';

import { env } from './env';

const environment = `${env.stage}-${Platform.OS}`;

const webConfig: ReactNativeOptions = {
  dsn: env.sentryDSN,
  release: env.releaseId,
  environment,
};

const nativeConfig: ReactNativeOptions = {
  dsn: env.sentryDSN,
  release: env.releaseId,
  environment,
  enabled: false,
};

export const sentryConfig = Platform.OS === 'web' ? webConfig : nativeConfig;
